import { IMakeRequest } from '../../utils/make_request';
import { parseResponse } from './helpers';
import { mergeBaseUri, mergePaths } from '@cian/http-api/shared';

export interface IValues {
  phone: string;
}

export function sendValidationCode(
  makeRequest: IMakeRequest,
  apiBaseUrl: string,
  values: IValues,
): Promise<{ secondsToRetry: number }> {
  return makeRequest({
    method: 'POST',
    body: JSON.stringify(values),
    uri: mergeBaseUri(apiBaseUrl, {
      path: (path: string) => mergePaths(path, '/v1/send-validation-code/'),
    }),
    withCredentials: true,
    headers: [['Content-Type', 'application/json']],
  }).then(parseResponse('Не удалось отправить код.'));
}
